<template>
  <div class="full-wrapper">
    <el-scrollbar class="bar-visible">
      <div class="full">
        <component :is="currentView" :active="active" />
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WHostClusterListView from './hostcluster';
import WHostListView from './host';
import WStorageClusterListView from './storagecluster';
import WStorageListView from './storage';

export default {
  name: 'WPerformanceNodeListview',
  components: {
    WHostClusterListView,
    WHostListView,
    WStorageClusterListView,
    WStorageListView,
  },
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      currentView: null,
    };
  },
  computed: mapGetters(['selectedNode']),
  watch: {
    selectedNode: {
      immediate: true,
      handler(to, from) {
        if (this.currentView === null || to.treeKey !== from.treeKey) {
          // TODO: 트리 타입마다 treeKey가 같아도 다른 노드일 수 있음. 해당 부분 처리 추가 필요함.
          this.changeView();
        }
      },
    },
    active: {
      handler() {
        this.changeView();
      },
    },
  },
  methods: {
    changeView() {
      if (this.selectedNode) {
        if (this.selectedNode.obj.objtypeId === 'VCL') {
          this.currentView = WHostClusterListView.name;
        } else if (this.selectedNode.obj.objtypeId === 'VHO') {
          this.currentView = WHostListView.name;
        } else if (this.selectedNode.obj.objtypeId === 'VDSC') {
          this.currentView = WStorageClusterListView.name;
        } else if (this.selectedNode.obj.objtypeId === 'VDS') {
          this.currentView = WStorageListView.name;
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/listview/index.vue